import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import { Div } from 'client/widget-components/basicComponents';
import {
    CheckboxChoice,
    CheckboxLimitations,
} from 'client/widget-components/ecom/stores/types';
import { mergeResponsiveStyles } from 'client/widget-components/responsive-styles/responsiveStylesService';
import React from 'react';
import { CUSTOMIZATIONS_DATA_GRABS } from '../../constants';
import { ProductCustomizationsStyles } from '../../types';
import CheckboxCustomizationChoice from './CheckboxCustomizationChoice';

interface CheckboxCustomizationChoicesProps {
    choices?: CheckboxChoice[];
    limitations?: CheckboxLimitations;
    value: string[];
    /** Max total units reached — disables `+` and the unselected checkboxes. */
    limitReached?: boolean;
    /** Editor-preview only: render every choice as selected (no state change). */
    previewAllSelected?: boolean;
    paidAddonTextStyles?: ProductCustomizationsStyles['checkboxPaidAddonText'];
    onChange: (label: string, checked: boolean) => void;
    onQuantityChange: (label: string, delta: number) => void;
    styles?: ProductCustomizationsStyles;
}

const CheckboxCustomizationChoices = ({
    choices,
    value,
    limitReached,
    previewAllSelected,
    styles,
    paidAddonTextStyles,
    onChange,
    onQuantityChange,
}: CheckboxCustomizationChoicesProps) => (
    <Div
        styles={mergeResponsiveStyles([
            defaultContainerStyles,
            styles?.choicesContainer,
        ])}
        data-grab={CUSTOMIZATIONS_DATA_GRABS.choicesContainerDataGrab}
    >
        {choices?.map((choice) => (
            <CheckboxCustomizationChoice
                key={choice.label}
                choice={choice}
                value={value}
                limitReached={limitReached}
                previewAllSelected={previewAllSelected}
                paidAddonTextStyles={paidAddonTextStyles}
                onChange={onChange}
                onQuantityChange={onQuantityChange}
                styles={styles}
            />
        ))}
    </Div>
);

export default CheckboxCustomizationChoices;

const defaultContainerStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'repeat(auto-fill, minmax(24px, 1fr))',
        rowGap: '8px',
        columnGap: '24px',
    },
    [RuntimeMediaQuery.MOBILE]: {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
};
